export const TYPE_OF_ANESTHESIA = 'typeOfAnesthesia';

/* eslint-disable no-shadow, no-unused-vars */
export enum AnesthesiaType {
  GENERAL = 'general',
  REGIONAL = 'regional',
  LOCAL = 'local'
}
